module.exports = __webpack_public_path__ + "img/impersonate.be2215a.svg";